import LogoAl from "../../assets/secti_logo_2023.png";
import "./styles.css";
import {
  Facebook,
  Instagram,
  YouTube,
  Twitter,
  Info,
  SupportAgent,
} from "@mui/icons-material";

export default function HeaderSecti() {
  return (
    <div className="headerSecti">
      <div className="imgLogoAl">
        <img src={LogoAl} alt="Estado de Alagoas — SECTI" />
      </div>

      <div className="iconsSectiContainer">
        <a className="linkSiteSecti" href="https://secti.al.gov.br/">
          ACESSE O SITE AGORA
        </a>
        <a className="iconsSecti" href="https://e-ouv.al.gov.br/">
          <SupportAgent sx={{ fontSize: 18, color: '#4caf50' }} />
        </a>
        <a
          className="iconsSecti"
          href="https://secti.al.gov.br/solicitacao-de-informacao"
        >
          <Info sx={{ fontSize: 18, color: '#2196f3' }} />
        </a>
        <a
          className="iconsSecti"
          href="https://www.facebook.com/secti.alagoas/"
        >
          <Facebook sx={{ color: '#fdf9f0' }} />
        </a>
        <a
          className="iconsSecti"
          href="https://www.instagram.com/sectialagoas/"
        >
          <Instagram sx={{ color: '#fdf9f0' }} />
        </a>
        <a
          className="iconsSecti"
          href="https://x.com/i/flow/login?redirect_after_login=%2Fsectialagoas"
        >
          <Twitter sx={{ color: '#fdf9f0' }} />
        </a>
        <a
          className="iconsSecti"
          href="https://www.youtube.com/user/Sectialagoas"
        >
          <YouTube sx={{ color: '#fdf9f0' }} />
        </a>
      </div>
    </div>
  );
}
